import React from 'react';
import { FormGroup, FormControl } from 'react-bootstrap';
import { useAttendance } from '../../../hooks/attendance/AttendanceContext';
import { useTranslation } from 'react-i18next';

/**
 * Componente para filtrar por grupo
 * Muestra un select con la lista de grupos disponibles
 */
const GroupFilter = () => {
  const { t } = useTranslation();
  const {
    filters: { groupId, handleGroupChange },
    groups: { list, loading, error }
  } = useAttendance();

  const handleChange = (e) => {
    handleGroupChange(e.target.value);
  };

  return (
    <FormGroup className="form-group form-search" controlId="filterGroupId">
      <FormControl
        as="select"
        value={groupId}
        onChange={handleChange}
        disabled={loading || error}
      >
        <option value="">{t('common.filterByGroup')}</option>
        {list && list.map(group => (
          <option key={group.id} value={group.id}>
            {group.name}
          </option>
        ))}
      </FormControl>
      {loading && <small className="text-muted">{t('attendance.loadingGroups')}</small>}
      {error && <small className="text-danger">{error}</small>}
    </FormGroup>
  );
};

export default GroupFilter;